import useFetch from 'utils/hooks/useFetch'
import { ApiDeleteTransaction, ApiGetCustomerPaymentList, ApiGetCustomerPaymentSummary, ApiGetCustomerRankStatistic, ApiGetDailyTransactionStatistic, ApiGetTransaction, ApiGetTransactionList, ApiGetTransactionReportEdc, ApiGetTransactionStatistic, ApiInsertTransaction, ApiProceedPayment, ApiUpdateTransaction } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'
import moment from 'moment'
import { InsertDateFormat } from 'utils/Constant'

export function TransactionService() {
    const { showFail } = useModal()

    const { fetch: apiGetTransactionList } = useFetch(ApiGetTransactionList)
    const { fetch: apiInsertTransaction } = useFetch(ApiInsertTransaction)
    const { fetch: apiDeleteTransaction } = useFetch(ApiDeleteTransaction)
    const { fetch: apiUpdateTransaction } = useFetch(ApiUpdateTransaction)
    const { fetch: apiGetTransaction } = useFetch(ApiGetTransaction)
    const { fetch: apiGetTransactionReportEdc } = useFetch(ApiGetTransactionReportEdc)

    const { fetch: getTransactionStatictic } = useFetch(ApiGetTransactionStatistic)
    const { fetch: getCustomerRank } = useFetch(ApiGetCustomerRankStatistic)
    const { fetch: getDailyTransactionStatistic } = useFetch(ApiGetDailyTransactionStatistic)

    const { fetch: apiGetCustomerPaymentList } = useFetch(ApiGetCustomerPaymentList)
    const { fetch: apiProceedPayment } = useFetch(ApiProceedPayment)
    const { fetch: apiGetCustomerPaymentSummary } = useFetch(ApiGetCustomerPaymentSummary)

    const fetchTransactionList = async(dateFrom, dateTo, customerName, cardNumber, edcId, status, pageSize, pageIndex, updateBy, locationId) =>{
        const res =  await apiGetTransactionList({
            data: {
                dateFrom: moment(dateFrom).format(InsertDateFormat),
                dateTo: moment(dateTo).format(InsertDateFormat),
                customerName,
                cardNumber,
                edcId,
                status,
                pageSize,
                pageIndex,
                updateBy,
                locationId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchTransactionById = async (transactionId) => {
        const res = await apiGetTransaction({
            data: {
                transactionId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchInsertTransaction = async(
        transactionDate, 
        customerCardId, 
        edcId, 
        mdrEdcOffUs, 
        mdrEdcOnUs, 
        mdrQrisOnUs, 
        mdrQrisOffUs, 
        mdrCreditAmex,
        mdrDebitOnUs,
        mdrDebitOffUs,
        type, 
        amount, 
        mdr, 
        netto,
        locationId,
        time, 
        paymentType, 
        transferAmount, 
        cashAmount, 
        remark, 
        beneficiaryId,
        reffNo
    ) => {
        const res =  await apiInsertTransaction({
            data: {
                transactionDate,
                customerCardId,
                edcId,
                mdrEdcOffUs,
                mdrEdcOnUs,
                mdrQrisOnUs,
                mdrQrisOffUs,
                mdrCreditAmex,
                mdrDebitOnUs,
                mdrDebitOffUs,
                type,
                amount,
                mdr,
                netto,
                locationId,
                time,
                paymentType,
                transferAmount,
                cashAmount,
                remark,
                beneficiaryId,
                reffNo
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateTransaction = async (
        transactionId,
        customerCardId, 
        transactionDate, 
        edcId, 
        mdrEdcOffUs, 
        mdrEdcOnUs, 
        mdrQrisOnUs, 
        mdrQrisOffUs, 
        mdrCreditAmex,
        mdrDebitOnUs,
        mdrDebitOffUs,
        type,
        amount,
        mdr, 
        netto,
        time,
        locationId,
        reffNo
    ) => {
        const res = await apiUpdateTransaction({
            data:{
                transactionId, 
                customerCardId,
                transactionDate,
                edcId,
                mdrEdcOffUs, 
                mdrEdcOnUs, 
                mdrQrisOnUs, 
                mdrQrisOffUs, 
                mdrCreditAmex,
                mdrDebitOnUs,
                mdrDebitOffUs,
                type, 
                amount, 
                mdr, 
                netto,
                time,
                locationId,
                reffNo
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteTransaction = async(transactionId, status) => {
        const res =  await apiDeleteTransaction({
            data: {
                transactionId,
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchTransactionReportEdc = async (dateFrom, dateTo, status) => {
        const res = await apiGetTransactionReportEdc({
            data: {
                dateFrom,
                dateTo,
                status
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    const fetchTransactionStatistic = async (accYear) => {
        const res = await getTransactionStatictic({
            data: {
                accYear
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCustomerRankStatistic = async (accYear, accMonth, numberOfCustomer, sortBy) => {
        const res = await getCustomerRank({
            data: {
                accYear,
                accMonth,
                numberOfCustomer,
                sortBy
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDailyTransactionStatistic = async (accYear, accMonth) => {
        const res = await getDailyTransactionStatistic({
            data: {
                accYear,
                accMonth
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    const fetchCustomerPaymentList = async (transactionDate, paymentStatus, status, type) => {        
        const res = await apiGetCustomerPaymentList({
            data: {
                transactionDate,
                paymentStatus,
                status,
                type
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchProceedPayment = async (data) => {
        const res = await apiProceedPayment({
            data: data
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCustomerPaymentSummary = async (transactionDate) => {
        const res = await apiGetCustomerPaymentSummary({
            data: {
                transactionDate
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchTransactionList,
        fetchTransactionById,
        fetchInsertTransaction,
        fetchUpdateTransaction,
        fetchDeleteTransaction,
        fetchTransactionReportEdc,
        fetchTransactionStatistic,
        fetchCustomerRankStatistic,
        fetchDailyTransactionStatistic,
        fetchCustomerPaymentList,
        fetchProceedPayment,
        fetchCustomerPaymentSummary
    }
}